export default function ($stateParams, miReportServiceFactory) {
    const vm = this;
    vm.reportName = $stateParams.reportName;

    vm.menu = [
        {
            title: 'Audit',
            children: [
                {
                    title: 'Operational Audit',
                    reportName: 'operationalAudit',
                    dateSelectionRequired: true,
                    textSelectionRequired: false
                }
            ]
        },
        {
            title: 'Workload Planning',
            children: [
                {
                    title: 'Enquiries under investigation',
                    reportName: 'enquiriesUnderInvestigation',
                    dateSelectionRequired: false,
                    textSelectionRequired: false
                },
                {
                    title: 'Enquiries by VMC account',
                    reportName: 'enquiriesByVmcAccount',
                    dateSelectionRequired: true,
                    textSelectionRequired: true,
                    textSelectionHeading: 'VMC Account'
                },
                {
                    title: 'Enquiries by Experian Account',
                    reportName: 'groupedEnquiriesByVmcAccount',
                    dateSelectionRequired: true,
                    textSelectionRequired: true,
                    textSelectionHeading: 'Experian Account'
                },
                { title: 'Volume of Tasks', reportName: 'volumeOfTasksCreated', dateSelectionRequired: true }
            ]
        },
        {
            title: 'BVRLA Hit reports',
            children: [
                { title: 'Historic (from Oct 2016)', reportName: 'HistoricBvrlaHits', dateSelectionRequired: false },
                { title: 'Prevoius Year', reportName: 'RegularBvrlaHits', dateSelectionRequired: false }
            ]
        }
    ];

    vm.selectedMenu = vm.menu
        .reduce((prev, m) => prev.concat(m.children), [])
        .find(e => e.reportName === vm.reportName);

    vm.miReportService = miReportServiceFactory(vm.reportName, vm.selectedMenu.dateSelectionRequired);

    vm.dateSelectionRequired = vm.selectedMenu.dateSelectionRequired;
    vm.textSelectionRequired = vm.selectedMenu.textSelectionRequired;
    vm.textSelectionHeading = vm.selectedMenu.textSelectionHeading;
}



// WEBPACK FOOTER //
// ./Client/app/mireports/controllers/reportGeneration/miReportDetailsCtrl.js